<template>
    <div class="f fh fa-c br-m oh ath-visual-breakdown" v-if="data">
        <span v-for="obj in data" :key="obj.uid" :style="obj.style" :class="[obj.cname]"></span>
    </div>
</template>

<script>
import { guuid, isNeArray, isNeObject, isNeString, isNumberGreaterThan, join } from '@aretheyhappy/utils';

export default {
    name: 'mead-breakdown',
    props: {
        /**
         * Array of segments to render as a proportional stacked bar. Each entry
         * should be an object with a `val` (positive number, used to compute the
         * segment's share of the total width) and an optional `type` (sentiment
         * key such as "positive"/"neutral"/"negative", used to color the segment;
         * defaults to "neutral" when omitted). Entries that aren't objects or whose
         * `val` isn't greater than 0 are skipped.
         */
        value       : {type: Array, default: () => []},
        /**
         * Border-radius modifier applied to each segment as `br-{cellRadius}`
         * (e.g. "0" for square corners, "m" for medium rounding).
         */
        cellRadius  : {type: String, default: () => '0'},
    },
    computed: {
        data: function () {
            if (!isNeArray(this.value)) return false;

            //  Get baseline total
            let total = 0;
            let vals = [];
            for (const el of this.value) {
                if (!isNeObject(el) || !isNumberGreaterThan(el.val, 0)) continue;
                total += el.val;
                vals.push(el);
            }

            //  Create output list
            vals = vals.map(el => Object.assign({uid: guuid()}, {
                style: {height: '100%', width: `${(el.val/total)*100}%`},
                cname: join([
                    isNeString(el.type) ? `el--t-${el.type}` : 'el--t-neutral',
                    `br-${this.cellRadius}`,
                ], {delim: ' '}),
            }));

            return isNeArray(vals) ? vals : false;
        },
    },
};
</script>

<style lang="scss" scoped>
span {
    &.el--t-pos,
    &.el--t-positive {
        background-color: var(--c-sentiment-positive-bg)
    }

    &.el--t-neu,
    &.el--t-neutral {
        background-color: var(--c-sentiment-neutral-bg);
    }

    &.el--t-neg,
    &.el--t-negative {
        background-color: var(--c-sentiment-negative-bg);
    }
}
</style>
